export const STORAGE_API = 'f2c__api';
